import { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { STATIC_IMAGE_URLS } from 'modules/core/constants';
import { COLORS } from 'modules/core/theme/colors';
import { getLenderState } from 'store/selectors/lenders.selector';

import {
  DecisionComment,
  DecisionCommentList,
  DecisionNote,
  DecisionNoteIcon,
  HoverNoteTooltip,
} from '../../../styles';
import { cleanDecisionComments } from '../../../utils/decisionComments';

const TOOLTIP_ID = 'route-one-decision-comments-tooltip';

/** The RouteOne decision comments, revealed on hover beside the Back Adds input. */
export const DecisionCommentsNote: FC = () => {
  const { t } = useTranslation();
  const rawComments = useSelector(getLenderState)?.dealSourceData?.decision_comments;
  const comments = useMemo(() => cleanDecisionComments(rawComments), [rawComments]);

  if (comments.length === 0) return null;

  return (
    <>
      <DecisionNote data-testid="decision-comments-note">
        {t('components.loanVariablesModal.infoMessages.decisionComments')}
        <DecisionNoteIcon
          src={STATIC_IMAGE_URLS.icons.externalLinkGrey}
          alt=""
          data-testid="decision-comments-icon"
          data-tooltip-id={TOOLTIP_ID}
          data-tooltip-place="top"
        />
      </DecisionNote>
      <HoverNoteTooltip id={TOOLTIP_ID} place="top" opacity={1} arrowColor={COLORS.WHITE} clickable>
        <DecisionCommentList data-testid="route-one-decision-comments">
          {comments.map((comment) => (
            <DecisionComment key={comment}>{comment}</DecisionComment>
          ))}
        </DecisionCommentList>
      </HoverNoteTooltip>
    </>
  );
};
